import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

interface ChartDataPoint {
  name: string;
  total: number;
  week: string;
}

interface HourLineChartProps {
  id?: string;
  data?: ChartDataPoint[];
  color?: string;
  height?: number;
}

const HourLineChart = ({
  id,
  data,
  color = "#82ca9d",
  height = 500,
}: HourLineChartProps) => {
  const gradientId = `gradient-${id || "default"}`;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart
        id={id}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={0.8} />
            <stop offset="95%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis xAxisId="0" dataKey="name" />
        <XAxis xAxisId="1" dataKey="week" allowDuplicatedCategory={false} />
        <YAxis tickCount={9} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend />
        <Area
          type="monotone"
          dataKey="total"
          stroke={color}
          strokeWidth={2}
          fillOpacity={1}
          fill={`url(#${gradientId})`}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default HourLineChart;
